module.exports = __webpack_public_path__ + "static/img/mrc.4505bf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mrc.png
// module id = 1x9O
// module chunks = 7 8